import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=430c4607&scoped=true&"
import script from "./Agenda.vue?vue&type=script&lang=js&"
export * from "./Agenda.vue?vue&type=script&lang=js&"
import style0 from "./Agenda.vue?vue&type=style&index=0&id=430c4607&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430c4607",
  null
  
)

export default component.exports